import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { FolderList } from "./FolderList/FolderList";
import { Table } from "./Table/Table";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getFolders } from "toolkit/documents/folders/folders.thunks";
import { NoData } from "components-new/NoData/NoData";
import styles from "./Folders.module.sass";

export const Folders: FC = () => {
	const { folderId } = useParams();
	const { condition, organizationId } = useParams();
	const dispatch = useAppDispatch();
	const { folders } = useAppSelector((state) => state.folders);

	useEffect(() => {
		dispatch(getFolders({ organizationId: Number(organizationId), archived: condition !== "current" }));
		//eslint-disable-next-line
	}, [organizationId, condition]);

	return (
		<>
			{folderId ? (
				<Table />
			) : (
				<section data-comment-false={true} className={styles.folders}>
					{condition === "current" && (
						<>
							<FolderList title="Системные папки" folders={folders.basic} />
							{folders.additional.length ? (
								<FolderList title="Дополнительные папки" folders={folders.additional} />
							) : null}
						</>
					)}
					{condition === "archive" &&
						(folders.additional.length || folders.basic.length ? (
							<>
								{folders.basic.length ? <FolderList title="Системные папки" folders={folders.basic} /> : null}
								{folders.additional.length ? (
									<FolderList title="Дополнительные папки" folders={folders.additional} />
								) : null}
							</>
						) : (
							<NoData title="Данные отсутствуют" />
						))}
				</section>
			)}
		</>
	);
};
